import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HygineReportService } from '../hygine-report.service';

@Component({
  selector: 'app-hygine-report-dialog',
  templateUrl: './hygine-report-dialog.component.html',
  styleUrls: ['./hygine-report-dialog.component.scss']
})
export class HygineReportDialogComponent implements OnInit {
  hygineId: any;
  imagedatalist: any;
  city: any;
  building: any;
  campus: any;
  created: any;
  block: any;
  Room: any;
  Floor: any;
  Activity: any;
  constructor(public dialogRef: MatDialogRef<HygineReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private hygine: HygineReportService) { }
  ngOnInit(): void {
    console.log("dialog", this.data);
    this.city = this.data.cityName
    this.campus = this.data.campusName
    this.building = this.data.buildingName
    this.block = this.data.blockName
    this.Floor = this.data.floorNumber
    this.Room = this.data.roomNo
    this.Activity = this.data.activityName
    this.created = this.data.createdOn
    this.imeagelist();
  }
  imeagelist() {
    this.hygineId = this.data?.hygieneId;
    if (!this.hygineId) return;

    this.hygine.imagelist(this.hygineId).subscribe({
      next: (res: any) => {
        this.imagedatalist = res.imageDetailsList || [];
      },
      error: (err) => {
        console.error('Error fetching images:', err);
      }
    });
  }
}
